module.exports = __webpack_public_path__ + "static/media/text-size-slider-button.f9f2250e.svg";